<template>
  <nav
    class="relative z-0 inline-flex items-center space-x-4 rounded-md"
    aria-label="Pagination"
  >
    <button
      class="relative inline-flex items-center rounded-l-md p-2 text-sm font-medium text-background-fg/70 disabled:opacity-30"
      :disabled="!resolvedEnablePrevious"
      @click="onPrevious"
    >
      <span class="sr-only">Previous</span>
      <IconChevronLeft class="size-5" aria-hidden="true" />
    </button>
    <div class="text-sm text-background-fg/70">
      <template v-if="pageCount !== undefined">
        page {{ page }} of {{ pageCount }}
      </template>
      <template v-else> page {{ page }} </template>
    </div>
    <button
      class="relative inline-flex items-center rounded-r-md p-2 text-sm font-medium text-background-fg/70 disabled:opacity-30"
      :disabled="!resolvedEnableNext"
      @click="onNext"
    >
      <span class="sr-only">Next</span>
      <IconChevronRight class="size-5" aria-hidden="true" />
    </button>
  </nav>
</template>
<script setup lang="ts">
const props = defineProps<{
  pageCount?: number
  enableNext?: boolean
  enablePrevious?: boolean
}>() // Expected to either have pageCount set, or both enableNext and enablePrevious set

const page = defineModel<number>("page", { required: true })

const resolvedEnableNext = computed(() => {
  if (props.pageCount !== undefined) {
    return page.value < props.pageCount
  }

  return props.enableNext ?? false
})

const resolvedEnablePrevious = computed(() => {
  if (props.pageCount !== undefined) {
    return page.value > 1
  }

  return props.enablePrevious ?? false
})

const onNext = () => {
  if (!resolvedEnableNext.value) return

  page.value += 1
}

const onPrevious = () => {
  if (!resolvedEnablePrevious.value) return

  page.value -= 1
}
</script>
